import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { CaretDownSolid, CaretUpSolid } from "@icons";
import { Header, flexRender } from "@tanstack/react-table";
import classNames from "classnames";

import { useTableContext } from "../context";

export default function TableColumnHeader({
  header,
}: {
  header: Header<unknown, unknown>;
}) {
  const { sortableFields, editMode } = useTableContext();

  const isSortable =
    !!header.column.getCanSort() && sortableFields?.includes(header.column.id);
  const toggleSortingHandler = header.column.getToggleSortingHandler();
  const sortDirection = header.column.getIsSorted();

  const isAscending = sortDirection === "asc";
  const isDescending = sortDirection === "desc";

  const { attributes, listeners, setNodeRef, isDragging, transform } =
    useDraggable({
      id: header.id,
    });

  return (
    <div
      className="flex items-center gap-2"
      style={{
        transform: CSS.Translate.toString(transform),
      }}
    >
      <div
        className={classNames(
          "flex gap-2 justify-center items-center cursor-grab",
          {
            "opacity-80 cursor-grabbing": isDragging,
          },
        )}
        ref={setNodeRef}
        {...listeners}
        {...attributes}
      >
        <span className="bg-primary-50">
          {header.isPlaceholder
            ? null
            : flexRender(header.column.columnDef.header, header.getContext())}
        </span>
      </div>
      {isSortable && !editMode && (
        <button
          className="flex flex-col items-center gap-1 text-gray-400 cursor-pointer"
          onClick={toggleSortingHandler}
          type="button"
        >
          <span
            className={classNames({
              "opacity-35": !isAscending,
            })}
          >
            <CaretUpSolid width={10} />
          </span>
          <span
            className={classNames({
              "opacity-35": !isDescending,
            })}
          >
            <CaretDownSolid width={10} />
          </span>
        </button>
      )}
    </div>
  );
}
